import { atomWithStorage } from "jotai/utils";

// base
export const devkeyJotai = atomWithStorage<string | undefined>("devkey", undefined);
export const bannerJotai = atomWithStorage<string | undefined>("banner", undefined);
